module.exports = __webpack_public_path__ + "static/media/28DGC1.30754fb7.jpg";